import { createSlice } from "@reduxjs/toolkit";

const initialWorkersState = {
  listLoading: false,
  entities: [],
  featuredAssetList: [],
  notificationList: [],
};

export const callTypes = {
  list: "list",
  action: "action",
};

export const dashboardSlice = createSlice({
  name: "dashboard",
  initialState: initialWorkersState,
  reducers: {
    catchError: (state, action) => {
      state.error = `${action.type}: ${action.payload.error}`;
      if (action.payload.callType === callTypes.list) {
        state.listLoading = false;
      } else {
        state.actionsLoading = false;
      }
    },
    startCall: (state, action) => {
      state.listLoading = true;
    },

    // dashboard loader
    dashboardListLoading: (state, action) => {
      state.listLoading = action.payload;
    },

    // load category list on dashboard
    categoryList: (state, action) => {
      state.entities = action.payload.slice(0, 9);
      state.listLoading = false;
    },
    // load featured Asset list on dashboard
    featuredAssetList: (state, action) => {
      state.featuredAssetList = action.payload.slice(0, 9);
      state.listLoading = false;
    },
    // load notification list
    notificationList: (state, action) => {
      state.notificationList = action.payload.slice(0, 9);
      state.listLoading = false;
    },
  },
});
